import { render, staticRenderFns } from "./AlterarFornecedor.vue?vue&type=template&id=4292dfc7&scoped=true"
import script from "./AlterarFornecedor.vue?vue&type=script&lang=js"
export * from "./AlterarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./AlterarFornecedor.vue?vue&type=style&index=0&id=4292dfc7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292dfc7",
  null
  
)

export default component.exports